import Vue from 'vue';

const EventBus = new Vue({
    name: 'EventBus'
});

export default EventBus;
